import { render, staticRenderFns } from "./WhPrint.vue?vue&type=template&id=8d1cd1e2&scoped=true"
import script from "./WhPrint.vue?vue&type=script&lang=js"
export * from "./WhPrint.vue?vue&type=script&lang=js"
import style0 from "./WhPrint.vue?vue&type=style&index=0&id=8d1cd1e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1cd1e2",
  null
  
)

export default component.exports